// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3O3J5","alert":"SettungsInbox_alert__2JWgu"};